export const HEADER_NAVIGATION_USER_BUTTON_ID = 'header-navigation-user-button';
